import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { MenuIcon } from '../../../../ui/common/icons';

const styles = require('./ordered-editor-item.css');

/** Props for the check item */
export interface OrderedEditorItemProps {
  /** Additional classes */
  className?: string;
  /** Embedded JSX element (Observer), or fallback to string (cf OrderedItem) */
  element: JSX.Element | string;
  /** Other fun stuff (eg. delete button) */
  control?: JSX.Element;
  /** Hint text */
  hintText?: string;
  /** Whether it is selected */
  isDragging: boolean;
  /** Outlined */
  outlined?: boolean;
}

/**
 * Container for editor element.
 */
@observer
export class OrderedEditorItem extends React.Component<OrderedEditorItemProps> {
  /** Renders the component */
  render() {
    return (
      <div
        className={classnames(
          styles.orderedEditorItem,
          this.props.outlined ? styles.outlined : undefined,
          this.props.isDragging ? styles.isDragging : undefined,
          this.props.className
        )}
      >
        <MenuIcon size="xsmall" color={this.props.outlined ? 'black' : undefined} />

        <div className={styles.orderedEditorItemLabel}>
          {this.props.hintText && <div className={styles.hintText}>{this.props.hintText}</div>}
        </div>
        <div className={styles.orderedEditorElement}>{this.props.element}</div>
        {this.props.control && <div className={styles.orderedEditorControl}>{this.props.control}</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/widgets/ordered-editor-item/ordered-editor-item.tsx